function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 1089 925.6",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: "10",
  strokeWidth: "28",
  transform: "matrix(.90884 0 0 .90884 49.685 42.194)",
  "data-name": "Layer_1"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "377.73",
  cy: "377.73",
  r: "363.73"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.74 150.44c19.18 269.69 223.27 488.27 486.22 529.66"
}), /*#__PURE__*/React.createElement("path", {
  d: "M579.96 680.1c29.53 4.65 59.81 7.06 90.65 7.06 65.42 0 128.31-10.86 186.95-30.88 88.61-25.97 165.61-1.12 202.9 61.39 30.82 51.67 15.51 123.14-73.84 193.92",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M207.41 449.76A574.469 574.469 0 0114.2 390.08M314.31 562.49c-6.37.21-12.76.31-19.18.31-94.01 0-182.78-22.43-261.25-62.23M466.84 650.25c-49.53 13.81-101.73 21.19-155.66 21.19-64.87 0-127.25-10.68-185.47-30.38M654.03 610.37c-260.68-45.89-461.19-266.38-476.45-536.4M709.33 536.46C471.2 481.75 289.2 280.02 264 31.93M734.01 451.29C541.18 384.36 394.72 218.24 355.69 14"
}))));